import React, { useEffect,useState,useRef } from "react";
import { useContext } from "react";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import ViewportContext from "../../../../context/studyviewer/ViewportContext";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import ThumbnailContext from "../../../../context/studyviewer/ThumbnailContext";
import themeContext from "../../../../context/theme/ThemeContext";

const Impressions = () => {
  const { impressions } = useContext(studyviewerContext);
  const { showImpressions ,setShowImpressions} = useContext(ViewportContext);
  const { getAlterColor,themeName,getAlterClass } = useContext(themeContext);

  const { getConsistentDateFormat } = useContext(studyReportContext);
  const {
    impressionHoveredStudyId,
    setImpressionHoveredStudyId,
    setSeriesHovered,
    seriesHovered,
  } = useContext(ThumbnailContext);

  const [isVisible, setIsVisible] = useState(showImpressions); 
  const impressionsContainerRef = useRef(null);   

  let timer;

  const onHovered = (key) => {
    timer = setTimeout(() => {
      setImpressionHoveredStudyId(impressions[key].studyId);
      setSeriesHovered(false);
    }, 300);
  };

  const onHoveredOut = () => {
    clearTimeout(timer);
    setImpressionHoveredStudyId(0);
  };

  useEffect(() => {
    if (seriesHovered) {
      const element = document.getElementById(
        "viewport-impression-" + impressionHoveredStudyId
      );
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        });
      }
    }
  }, [impressionHoveredStudyId]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        impressionsContainerRef.current &&
        !impressionsContainerRef.current.contains(event.target)
      ) {
        setIsVisible(false);
        setShowImpressions(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
  }, []);

  useEffect(() => {
    setIsVisible(showImpressions);
  }, [showImpressions]);

  return (
    <>
      {isVisible && (
        <div ref={impressionsContainerRef} className="viewport-impressions-container modal-scroll">
          {Object.keys(impressions).length > 0 &&
            Object.keys(impressions).map((key, index) => {
              if (index == 0) {
                return (
                  <>
                    {/* <div className="viewport-impressions-study-date"></div> */}
                    <div
                      id={`viewport-impression-${impressions[key].studyId}`}
                      style={{color: getAlterColor("#D5D5D5","")}}
                      className={`viewport-impressions-text ${
                        impressionHoveredStudyId === impressions[key].studyId
                          ? "highlight-impression"
                          : ""
                      }`}
                      onMouseEnter={() => onHovered(key)}
                      onMouseLeave={onHoveredOut}
                    >
                      <span className="viewport-impression-date" style={{color: getAlterColor("#ABABAB","")}}>
                        {getConsistentDateFormat(impressions[key].uploadDate)}
                      </span>
                      <span style={{ height: "5px" }}></span>
                      <span
                        className="viewport-impression-text-value"
                        dangerouslySetInnerHTML={{
                          __html: impressions[key].impressionText,
                        }}
                      ></span>
                    </div>
                  </>
                );
              } else {
                return (
                  <>
                    <div className={getAlterClass(themeName,"viewport-impressions-study-date")}></div>
                    <div
                      id={`viewport-impression-${impressions[key].studyId}`}
                      style={{color: getAlterColor("#D5D5D5","")}}
                      className={`viewport-impressions-text ${
                        impressionHoveredStudyId === impressions[key].studyId
                          ? "highlight-impression"
                          : ""
                      }`}
                      onMouseEnter={() => onHovered(key)}
                      onMouseLeave={onHoveredOut}
                    >
                      <span className="viewport-impression-date" style={{color: getAlterColor("#ABABAB","")}}>
                        {getConsistentDateFormat(impressions[key].uploadDate)}
                      </span>
                      <span style={{ height: "5px" }}></span>
                      <span
                        className="viewport-impression-text-value"
                        dangerouslySetInnerHTML={{
                          __html: impressions[key].impressionText,
                        }}
                      ></span>
                    </div>
                  </>
                );
              }
            })}
        </div>
      )}
    </>
  );
};

export default Impressions;
